<template>
  <div class="flex flex-col">
    <label class="border-gray-300 border-b-2 pb-1"
      v-if="display">
      <div class="flex flex-row">
        <div class="mr-2">
          <slot></slot>
        </div>
        <div class="flex-grow text-sm text-gray-300 text-end"
          v-if="loadingOptions">
          Loading Options...
        </div>
      </div>
      <div class="flex flex-row">
        <v-select class="border-gray-300 flex-grow"
          id="changeViewItem"
          v-if="canChange"
          :options="options"
          label="label"
          v-model="localValue"
          @input="onChangeVSelect"
          :reduce="option => option.value"
          placeholder="Add To Filter">
        </v-select>
        <Button
          class="rounded-r-2xl w-10 h-10 p-2 text-lg content-center justify-center"
          color="blue"
          @click="addOption(localValue)"
          v-if="canChange && canAdd">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="white">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 4v16m8-8H4"
            />
          </svg>
        </Button>
      </div>
    </label>
    <div class="flex flex-col gap-1"
      v-if="currentData !== undefined && currentData.length > 0">
      <ItemDisplay
        v-for="id in currentData"
        :key="id"
        :id="id"
        :type="callbackId"
        :canChange="canChange"
        :canDelete="canDelete"
        @deleteOption="deleteOption"
      />
    </div>
    <div
      v-else>
      <span class="text-gray-300">
        Not Filtering on <slot />
      </span>
    </div>
  </div>
</template>

<script>
import Button from '../../Button.vue'
// import XButton from '../../XButton.vue'

import ItemDisplay from './ItemDisplay.vue'

export default {
  components: {
    Button,
    // XButton,
    ItemDisplay,
  },
  props: {
    callbackId: String,
    display: Boolean,
    options: Array,
    currentData: {
      type: [Array, undefined],
      default: undefined,
    },
    value: [String, Number],
    canChange: Boolean,
    canDelete: {
      type: Boolean,
      default: true,
    },
    canAdd: {
      type: Boolean,
      default: true,
    },
    loadingOptions: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      localValue: this.value
    }
  },
  methods: {
    onChangeVSelect(vSelectEvent) {
      this.localValue = vSelectEvent
      this.$emit('input', vSelectEvent)
    },
    addOption() {
      if (this.canAdd && this.localValue) {
        this.$emit('addOption', this.callbackId, this.localValue)
      }
    },
    deleteOption(optionId) {
      if (this.canDelete && optionId) {
        this.$emit('deleteOption', this.callbackId, optionId)
      }
    },
  },
  // mounted() {
  // }
}
</script>
